import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'select',
      label: '第三方',
      filterable: true,
      clearable: true,
      placeholder: '请选择第三方',
      otherOptions: {
        changeField: 'sourceLabel',
        changeUrl: '/main/customerChannel/queryChannelByThirdParty',
        params: [{key: 'thirdParty', field: 'thirdParty'}]
      },
      rules: {required: true, message: '请选择所属第三方', trigger: 'blur'}
    },
    {
      field: 'sourceLabel',
      type: 'select',
      label: '渠道名称',
      filterable: true,
      clearable: true,
      placeholder: '请选择所属渠道',
      rules: {required: true, message: '请选择对应渠道', trigger: 'blur'}
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
      },
      rules: {required: true, message: '请选择加入时间', trigger: 'blur'}
    },
    {
      field: 'cfddFlag',
      type: 'switch',
      label: '重复兜底开关'
    },
  ]
}
